import {useState} from 'react';
import Button from '@/components/formElements/Button';
import utils from '@/utils/Utils';
import CnForm from '@/helpers/tracking/CnForm';
import checkRequiredFields from '@/helpers/tracking/checkRequiredFields';
import toast from 'react-hot-toast';
import Loader from '@/components/Loader';

interface PopupProps {
    id?: string;
    data: any;
    closePopup: () => void;
}

export default function ExtendStoragePeriodPopup({data, closePopup}: PopupProps) {
    const shipmentInfo = data.shipmentInfo[0];
    const [load, setLoad] = useState(false);
    const [fields, setFields] = useState({
        shipmentNumber: {
            name: 'shipmentNumber',
            label: 'LBL_SHIPMENT_NR',
            required: true,
            readonly: true,
            hidden: true,
            value: shipmentInfo.shipmentNr,
        },
        phone: {
            name: 'phone',
            label: 'LBL_DELIVERY_PHONE',
            required: true,
            error: false,
            errorHelperText: '',
            value: shipmentInfo.recipientPhone,
        },
        email: {
            name: 'email',
            label: 'LBL_DELIVERY_MAIL',
            required: true,
            type: 'email',
            error: false,
            errorHelperText: '',
            value: shipmentInfo.recipientMail,
        },
        date: {
            name: 'date',
            label: 'LBL_DATE',
            required: true,
            fieldType: 'date',
            error: false,
            errorHelperText: '',
            disablePast: true,
            maxDateDays: 14,
        },
        message: {
            name: 'message',
            fieldType: 'textarea',
            value: 'Žádost o prodloužení doby uložení do ',
            hidden: true,
        },
        requestType: {
            name: 'requestType',
            value: 'question_om_box',
            hidden: true,
        },
    });

    /**
    * @param {string} value
    * @param {string} name
    */
    const changeValue = (value, name) => {
        setFields((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
            },
        }));
    };

    /**
     *
     */
    const sendForm = async () => {
        if (!checkRequiredFields(fields, null, setFields) || load) {
            return;
        }

        setLoad(true);

        const postData = {
            message: '',
            date: '',
            language: utils.getLanguage(),
        };

        Object.keys(fields).forEach((key) => {
            const field = fields[key];
            postData[key] = field.value;
        });

        postData.message = postData.message + utils.formatDate(postData.date, true);

        const header = {recipientZip: utils.getRecipientZIP(shipmentInfo.shipmentNr)};

        try {
            const response = await utils.post('request/create', postData, header);

            if (response?.status) {
                toast.success(utils.useTranslate('LBL_EXTEND_REQUEST_CREATED'));
                closePopup();
                window.open(`${window.location.protocol}//${window.location.host}/request/${response.data.requestHash}`, '_blank');
                setLoad(false);
            } else {
                toast.error(utils.useTranslate('LBL_CS_REQUEST_WAS_NOT_CREATED'));
                closePopup();
                setLoad(false);
            }
        } catch (error) {
            console.error(error);
            utils.handleCnTimeOut(error);
            setLoad(false);
        }
    };

    return (
        <div className="popupContentWrapper infoPopup">
            <div className="popupContent">
                <div className='trackingForm'>
                    <CnForm loaded={true} fields={fields} onChange={changeValue} />
                </div>
            </div>

            <div className="popupButtons">
                <Button onClick={() => closePopup()} variant='light'>
                    <span className='tabLabel bold'>{utils.useTranslate('LBL_CANCEL_BTN')}</span>
                </Button>
                <Button onClick={() => sendForm()} variant='primary'>
                    <span className='tabLabel bold'>{utils.useTranslate('LBL_CONFIRM_BTN')}</span>
                </Button>
            </div>
            {load ? <Loader /> : null}
        </div>
    );
}
